/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Class used to define PAYMENT_LINK payment related data
 */
export type PaymentLinkDTO = {
    /**
     * Deadline for the merchant to receive the payment
     */
    expirationDate?: string;
    /**
     * Merchant business name associated with operation
     */
    merchantBusinessName?: string;
    /**
     * Merchant first name associated with operation
     */
    merchantFirstName?: string;
    /**
     * Merchant last name associated with operation
     */
    merchantLastName?: string;
    /**
     * Merchant trading name associated with operation
     */
    merchantTradingName?: string;
    /**
     * Payment link that has been generated
     */
    operationCode?: string;
    /**
     * Order id for the generated payment link
     */
    orderId?: string;
    /**
     * Payment method used to complete payment link operation
     */
    paymentLinkMethod?: PaymentLinkDTO.paymentLinkMethod;
};

export namespace PaymentLinkDTO {

    /**
     * Payment method used to complete payment link operation
     */
    export enum paymentLinkMethod {
        CASH = 'CASH',
        POS = 'POS',
        USSD = 'USSD',
        QR_CODE = 'QR_CODE',
        IN_BANK_TRANSFER = 'IN_BANK_TRANSFER',
        INWARDS_TRANSFER = 'INWARDS_TRANSFER',
        PAY_WITH_TRANSFER = 'PAY_WITH_TRANSFER',
        MOMO = 'MOMO',
        PAYMENT_LINK = 'PAYMENT_LINK',
        OUT_BANK_TRANSFER = 'OUT_BANK_TRANSFER',
        REFUND = 'REFUND',
        CARD = 'CARD',
    }


}
